import { useEffect } from "react";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import { getRole } from "../../helpers/ReduxHelpers";

export function SetupUser() {
  const userInfo = useSelector((state) => state.user.userInfo);
  // console.log('User Info:', userInfo);
  
  useEffect(() => {
    if (userInfo?.id) {
      // Get roles from JWT token
      const roles = getRole();
      
      const customProperties = {
        user_name: userInfo?.merchant?.name || 'Unknown',
        user_role: roles.join(', ') || 'Unknown',
        primary_role: roles[0] || 'Unknown',
        merchant_id: userInfo?.merchant?.id || 'Unknown'
      };
      
      console.log('Setting GA4 User Properties:', customProperties);
      
      // Set user ID
      ReactGA.set({
        userId: userInfo.id
      });

      // Set user properties using GA4 gtag method
      ReactGA.gtag('config', process.env.REACT_APP_GA_ID, {
        user_properties: customProperties
      });

      // Send a custom event with user context using gtag directly
      ReactGA.gtag('event', 'user_identified', {
        event_category: 'User',
        event_label: 'User Login',
        user_name: customProperties.user_name,
        user_role: customProperties.user_role,
        primary_role: customProperties.primary_role,
        merchant_id: customProperties.merchant_id
      });
      
      console.log('Sent user_identified event with custom parameters using gtag');
    }
    
    return () => {
      ReactGA.set({ userId: null });
    };
  }, [userInfo?.id, userInfo?.username, userInfo?.merchant?.name, userInfo?.merchant?.id]);

  return null;
}
